import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

/**
 * /refund.
 *
 * The copy was `includes/modules/legal/returns.html`, written out here rather than passed
 * in as a document, which is how DiscountMags' refund page already works. That module
 * rendered only in the checkout lightbox, and the checkout agreement links to this page
 * instead now, so it is gone and this component is the one published copy.
 *
 * "Refund Policy" is DiscountMags' name for this page, which is the name to use per the
 * brief. The legacy page disagreed with itself about its own: its `<h1>` said "MagSpot.com
 * Refund Policy" while its breadcrumb said "Cancellation Policy". The template still keeps
 * its own `<title>`.
 */
export default function RefundPolicy() {
  const { buildUrl } = useUrlGenerator();

  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Refund Policy' }]} />

      <PageHeading eyebrow="Customer Information">Refund Policy</PageHeading>

      <ContentCard className="prose mt-6">
        <p>
          We strive in making sure our customers have the most positive experience with us. If you
          are not 100% satisfied with your subscription(s) for any reason within 6 months of
          purchase, let us know by{' '}
          <a href={buildUrl('/contact')}>contacting our customer service</a> to cancel and refund
          your subscription(s). A pro-rated refund will be issued for all undelivered issues.
        </p>

        <p>
          Please allow 48 hours for the refund to process into your account. This could take up to
          5-7 business days depending on your bank.
        </p>
      </ContentCard>
    </>
  );
}

RefundPolicy.layoutName = 'Layouts.Institutional';
